import Vue from 'vue'
import Vuex from 'vuex'
// import custom pathify config (this is optional!)
import pathify from './pathify'
import { Decode } from '@/services'

// import helper function
import { make } from 'vuex-pathify'

// setup store
const state = {
  key: Decode.decode(localStorage.getItem('key')),
  key_object: {},
  header: { 
    headers: {
      Authorization: ''
    } 
  }
}

const actions = {
  CheckAuth ({state}) {
    const data = state.key ? JSON.parse(state.key) : {}
    state.key_object = data
    state.header.headers.Authorization = data.Authorization
  },
  ClearData ({state}) {
    state.key = ''
    state.key_object = {}
    state.header.headers.Authorization = ''
  }
}

const mutations = make.mutations(state)

// use store
Vue.use(Vuex)

// create store
export default new Vuex.Store({

  // use the plugin
  plugins: [
    pathify.plugin
  ],

  // store properties
  state,
  mutations,
  actions
})



// WEBPACK FOOTER //
// ./src/pathify/store.js